
const digest = '462a097ada7b7f046fd5a9709b3cf28be5be5b09a6a704b7e9b96b501ce8128b';
const classes = {"button":"_button_17q4f_1","active":"_active_17q4f_9","disabled":"_disabled_17q4f_18"};
const css = `._button_17q4f_1 {
  color: #1665d8;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 12px 0;
}
._button_17q4f_1._active_17q4f_9 {
  color: #1553aa;
  background-color: #dce7f9;
  border-radius: 5px;
  text-decoration: none;
  padding: 5px 10px;
  margin: 7px 0;
  height: fit-content;
}
._button_17q4f_1._disabled_17q4f_18 {
  color: #737373;
  cursor: not-allowed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  